<template>
  <v-dialog
    :max-width="maxWidth"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Enviar Pedido</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-alert
            color="blue"
            dark
            outlined
            v-if="paciente.mail == '' || paciente.mail == null"
            >El paciente no tiene registrado un mail en su ficha, puede
            introducir uno a continuación.</v-alert
          >
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-if="tipoEnvio === 'mail'"
                v-model="email"
                prepend-icon="mdi-email"
                label="E-mail *"
                :rules="emailRules"
                dense
                maxlength="80"
              ></v-text-field>
              <v-text-field
                v-else
                v-model="celular"
                prepend-icon="mdi-whatsapp"
                label="Celular *"
                :rules="celularRules"
                hint="Ingrese el celular con la característica, sin 0, sin 15 y sin guiones. Ej: 1135036549"
                dense
                maxlength="80"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="!valid" @click.stop="enviarEvento"
            >Enviar {{ tipoEnvio === "mail" ? "Mail" : "Whats app" }}</v-btn
          >

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<style scoped>
.multi-line {
  white-space: pre-line;
}
.v-dialog__content {
  align-items: left;
  justify-content: left;
}
</style>
<script>
import axios from "../../axios-auth.js";
import imprimirPedido from "../HistClin/ImprimirEventos/imprimirPedido";
import imprimirPedidoTrinidad from "../HistClin/ImprimirEventos/Trinidad/imprimirPedido";

export default {
  data: (vm) => ({
    valid: false,
    lazy: false,
    maxWidth: "100%",
    base64: null,
    email: "",
    celular: "",
    celularRules: [(v) => !v || v.length == 10 || "Debe tener 10 caracteres"],
    emailRules: [
      (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
      (v) => !!v || "Dato obligatorio",
    ],
  }),
  props: ["visible", "pedido", "paciente", "institucion", "tipoEnvio"],
  computed: {
    show: {
      get() {
        if (this.visible) {
          this.getLogoUrl();
          this.setearModels();
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    enviarEvento() {
      if (this.tipoEnvio === "mail") {
        this.enviarMail();
      } else {
        this.enviarWA();
      }
    },
    setearModels() {
      this.email = this.paciente.mail;
      this.celular = this.paciente.celular;
      if (this.$store.state.videollamada == true) this.maxWidth = "68%";
      else this.maxWidth = "100%";
    },
    getLogoUrl() {
      let self = this;

      axios
        .get("/HistoriaClinica/GetLogo?", {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          },
        })
        .then((response) => {
          self.base64 = response.data;
        })
        .catch((error) => {});
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
    enviarUrlPedidoPorMail() {
      let self = this;
      this.$swal({
        title: "Enviar Pedido",
        text: "¿Desea enviar el pedido por email al paciente?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        const datosPedido = {
          urlPedido: this.pedido.urlPedido,
          idPaciente: this.paciente.idPaciente,
          mail: this.email,
          idProfesional: this.pedido.idProfesional,
        };
        try {
          await axios
            .post("/HistoriaClinica/EnviarPedidoElectronico", datosPedido)
            .then((response) => {
              self.showAlert({
                icon: "success",
                title: "Pedido electrónico enviado exitosamente",
                vm: self,
                timer: 3000,
              });
              self.show = false;
            });
        } catch (error) {
          self.showAlert({
            icon: "error",
            title: "El pedido electrónico no pudo ser enviada.",
            vm: this,
            timer: 3000,
          });
        }
      });
    },
    enviarWA() {
      let file = null;
      switch (this.$store.state.usuario.institucion.idInstitucion) {
        case 95: {
          file = imprimirPedidoTrinidad(
            this.institucion,
            this.paciente,
            this.pedido,
            this.base64,
            "file"
          );
          break;
        }
        default: {
          file = imprimirPedido(
            this.institucion,
            this.paciente,
            this.pedido,
            this.base64,
            "file"
          );
          break;
        }
      }

      this.$swal({
        title: "Enviar Pedido",
        text: "¿Desea enviar el pedido por whats app al paciente?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          var datosReceta = new FormData();
          datosReceta.append("file", file);
          datosReceta.append("celular", this.celular);
          datosReceta.append(
            "idInstitucion",
            this.$store.state.usuario.institucion.idInstitucion
          );
          datosReceta.append("idPaciente", this.paciente.idPaciente);
          datosReceta.append("tipoEvento", "pedido");
          datosReceta.append("idProfesional", this.pedido.idProfesional);
          let self = this;
          axios({
            method: "post",
            url: "/HistoriaClinica/EnviarEventoWA",
            data: datosReceta,
            header: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title:
                  "Se envió un mensaje de whats app al paciente con el pedido.",
                vm: self,
                timer: 3000,
              });
              self.show = false;
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El pedido no pudo ser enviado.",
                vm: this,
                timer: 3000,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    enviarMail() {
      if (this.pedido.urlPedido) {
        this.enviarUrlPedidoPorMail();
        return;
      }

      let file = null;

      switch (this.$store.state.usuario.institucion.idInstitucion) {
        case 95: {
          file = imprimirPedidoTrinidad(
            this.institucion,
            this.paciente,
            this.pedido,
            this.base64,
            "file"
          );
          break;
        }
        default: {
          file = imprimirPedido(
            this.institucion,
            this.paciente,
            this.pedido,
            this.base64,
            "file"
          );
          break;
        }
      }

      this.$swal({
        title: "Enviar Pedido de Estudio",
        text: "¿Desea enviar el pedido de estudio por email al paciente?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          var datosPedido = new FormData();
          datosPedido.append("file", file);
          datosPedido.append("email", this.email);
          datosPedido.append(
            "idInstitucion",
            this.$store.state.usuario.institucion.idInstitucion
          );
          datosPedido.append("idPaciente", this.paciente.idPaciente);
          datosPedido.append("idPedido", this.pedido.idPedido);
          let self = this;
          axios({
            method: "post",
            url: "/HistoriaClinica/EnviarPedido",
            data: datosPedido,
            header: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
            },
          })
            .then((response) => {
              self.showAlert({
                icon: "success",
                title:
                  "Se envió un mail a la casilla de correo indicada con el pedido de estudio.",
                vm: self,
                timer: 3000,
              });
              self.show = false;
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "La pedido de estudio no pudo ser enviada.",
                vm: this,
                timer: 3000,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
  },
};
</script>
